import React, { useCallback, useRef } from 'react';
import { nanoid } from 'nanoid';
import { Container, Input, Label, StuntDouble } from "./Checkbox.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 *  A simple Checkbox component.
 *  It can be used as a controlled or uncontrolled component.
 *
 * @param disabled If the checkbox is disabled
 * @param label Label of the checkbox
 * @param size Size of the checkbox
 * @param checked If the checkbox is checked
 * @param onChange Function to be called when the checkbox value changes
 */
const Checkbox = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    disabled,
    label,
    size = 'md',
    checked,
    onChange,
    ...rest
  } = props;
  const elemId = useRef(nanoid(10));
  const handleClick = useCallback(() => {
    const input = document.getElementById(elemId.current);
    if (!disabled && input) {
      input.checked = !input.checked;
      onChange?.({
        target: input
      });
    }
  }, [disabled]);
  return /*#__PURE__*/_jsxs(Container, {
    size: size,
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(Input, {
      ...rest,
      id: elemId.current,
      type: "checkbox",
      disabled: disabled,
      checked: checked,
      onChange: onChange,
      ref: ref,
      inputSize: size
    }), /*#__PURE__*/_jsx(StuntDouble, {
      size: size,
      onClick: handleClick,
      disabled: disabled
    }), label && /*#__PURE__*/_jsx(Label, {
      htmlFor: elemId.current,
      size: size,
      disabled: disabled,
      children: label
    })]
  });
});
Checkbox.displayName = 'Checkbox';
export { Checkbox };